import vial from "../../../imgs/vial.png";
import pens from "../../../imgs/pens.png";
import clinician from "../../../imgs/clinician.png";
import t from "utils/translate";

const applangaKeyMap = {
  compound: {
    headline: "COMPOUNDED_GLP1_CARD_HEADLINE",
    subheading: "COMPOUNDED_GLP1_CARD_SUBHEADING",
    details: "COMPOUNDED_GLP1_CARD_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_COMPOUNDED_SEMAGLUTIDE",
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS"
    ],
    img: vial,
    offer: {
      headline: "COMPOUNDED_GLP1_CONSULTATION_OFFER",
      details: "",
      priceCrossout: "$49",
      price: "$0"
    }
  },
  wegovy: {
    headline: "CASH_PAY_WEGOVY_CARD_HEADLINE",
    subheading: "CASH_PAY_WEGOVY_PAGE_SUBHEADING",
    details: "CASH_PAY_WEGOVY_PAGE_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_WEGOVY",
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS"
    ],
    img: t("CASH_PAY_WEGOVY_CARD_IMAGE"),
    offer: {
      headline: "CASH_PAY_WEGOVY_OFFER_HEADLINE",
      details: "CASH_PAY_WEGOVY_OFFER_DETAILS",
      priceCrossout: t("CASH_PAY_WEGOVY_OFFER_PRICE_CROSSOUT"),
      price: t("CASH_PAY_WEGOVY_OFFER_PRICE")
    },
    disclaimers: ["CASH_PAY_WEGOVY_DISCLAIMER", "FIRST_MONTH_FREE_DISCLAIMER"]
  },
  insurance: {
    headline: "INSURANCE_COVERED_GLP1_CARD_HEADLINE",
    subheading: "INSURANCE_COVERED_GLP1_CARD_SUBHEADING",
    details: "INSURANCE_COVERED_GLP1_CARD_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS",
      "CHECKLIST_ITEM_LIVE_SUPPORT_GROUPS"
    ],
    img: pens,
    disclaimers: ["FIRST_MONTH_FREE_DISCLAIMER"]
  },
  clinician: {
    headline: "DECIDE_WITH_CLINICIAN_CARD_HEADLINE",
    subheading: "DECIDE_WITH_CLINICIAN_CARD_SUBHEADING",
    bulletlist: [
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS",
      "CHECKLIST_ITEM_LIVE_SUPPORT_GROUPS"
    ],
    img: clinician,
    disclaimers: ["FIRST_MONTH_FREE_DISCLAIMER"]
  },
  none: {
    headline: "NONE_CARD_HEADLINE",
    subheading: "INSURANCE_COVERED_GLP1_CARD_SUBHEADING",
    details: "INSURANCE_COVERED_GLP1_CARD_DETAILS",
    bulletlist: [
      "CHECKLIST_ITEM_CLINICIAN_VISIT",
      "CHECKLIST_ITEM_WEIGHT_LOSS_TREATMENT",
      "CHECKLIST_ITEM_UNLIMITED_MESSAGING",
      "CHECKLIST_ITEM_FITNESS_PLANS",
      "CHECKLIST_ITEM_LIVE_SUPPORT_GROUPS"
    ],
    img: pens,
    disclaimers: ["FIRST_MONTH_FREE_DISCLAIMER"]
  }
};

export default applangaKeyMap;
